import { FlightState, TypeFlight } from "@/lib/redux/features/flight/type"

export const byPoints = (state: FlightState, flight: TypeFlight) => {
  const firstSegment = flight.segments[0]
  const lastSegment = flight.segments[flight.segments.length - 1]
  const selectedInput = state.inputFlights[state.selectedFligthInputIndex]
  return firstSegment.startPoint === selectedInput.fromAirport?.code && lastSegment.endPoint === selectedInput.toAirport?.code
}